const INVALID_TOKEN_TRAITS : { trait: TraitMapItem; value: TraitValue }[] = [
    {
        trait: { id: -1, name: "probably", values: null },
        value: { traitId: -1, id: -1, label: "nothing", amount: 0 },
    },
];

export default INVALID_TOKEN_TRAITS;
